import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata
} from '../../client-server-common';
import type {Values} from '@wix/devzai-utils-common';

export const DoppeActionTypeEmbedIframeEmbedType = {
    Standard: 'standard',
} as const;

export type DoppeActionTypeEmbedIframeEmbedType = Values<typeof DoppeActionTypeEmbedIframeEmbedType>;


export namespace DoppeActionTypeEmbedIframe {


    export interface ActionSettings {
        url: string;
        embedType: DoppeActionTypeEmbedIframeEmbedType;
        height: number;
    }

}

export const doppeActionTypeEmbedIframe = doppeActionTypeDefineMetadata<DoppeActionTypeEmbedIframe.ActionSettings>({
    id: 'io.bymo.action/iframe-embed',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        url: '',
        embedType: DoppeActionTypeEmbedIframeEmbedType.Standard,
        height: 360
    }),
    hasNoGoalMeasuring: true,
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            url: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Url, BymoPagePropsContentSettingSemanticMeaning.EntityPageUrl)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
    hasNoLockInnerCTA: true,
})